
import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext();

export function useChat() {
    return useContext(ChatContext);
}

export function ChatProvider({ children }) {
    const [activeChat, setActiveChat] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [mensagemInicial, setMensagemInicial] = useState('');

    const openChat = (usuario, msgPrevia = '') => {
        setActiveChat(usuario);
        setMensagemInicial(msgPrevia);
        setIsOpen(true);
    };

    const closeChat = () => {
        setIsOpen(false);
        setActiveChat(null);
        setMensagemInicial('');
    };

    const value = {
        activeChat,
        isOpen,
        mensagemInicial,
        setMensagemInicial,
        openChat,
        closeChat
    };

    return (
        <ChatContext.Provider value={value}>
            {children}
        </ChatContext.Provider>
    );
}
